export const handleRedirect = () => {
  window.open('/onboarding/redirectAction');
};

export const handleChallenge = () => {
  window.open('/onboarding/challengeAction');
};

export const handleIdentifyShopper = () => {
  window.open('/onboarding/identifyShopperAction');
};

export const handle3dsData = (paymentData: any) => {
  const { threeDS1, identifyShopperData, challengeShopperData } = paymentData;

  if (threeDS1) {
    handleRedirect();
  } else if (identifyShopperData) {
    handleIdentifyShopper();
  } else if (challengeShopperData) {
    handleChallenge();
  }
};

export const parsePaymentMethods = (paymentMethods: any) => ({
  paymentMethods: paymentMethods.paymentMethods
    .map((payment: any) =>
      payment?.type === 'paypal'
        ? {
            ...payment,
            configuration: {
              merchantId: payment.configuration.entry.find(
                (entry: any) => entry.key === 'merchantId'
              ).value,
              intent: payment.configuration.entry.find(
                (entry: any) => entry.key === 'intent'
              ).value,
            },
          }
        : null
    )
    .filter((n: any) => n),
});

export const parseDropinPaymentMethods = (paymentMethods: any) => ({
  paymentMethods: paymentMethods.paymentMethods
    .map((payment: any) =>
      payment?.type === 'paypal'
        ? {
            ...payment,
            configuration: {
              merchantId: payment.configuration.entry.find(
                (entry: any) => entry.key === 'merchantId'
              ).value,
              intent: payment.configuration.entry.find(
                (entry: any) => entry.key === 'intent'
              ).value,
            },
          }
        : payment
    )
    .filter((n: any) => n),
});

const convertToFullLocale = (shortLocale) => {
  const localeMap = {
    en: 'en-US',
    de: 'de-DE',
    fr: 'fr-FR',
    it: 'it-IT',
    pl: 'pl-PL',
    sk: 'sk-SK',
    cz: 'cs-CZ',
    tr: 'tr-TR',
    deformal: 'de-DE',
  };

  return localeMap[shortLocale] || 'de-DE'; // fallback to de
};

// Keep your existing configuration function
export const getAdyenCheckoutConfigs = (
  locale,
  country,
  clientKey,
  paymentMethods,
  onSubmitDropinPayment,
  onSubmitDropinPaymentDetails
) => ({
  paymentMethodsResponse: paymentMethods,
  clientKey: clientKey,
  locale: convertToFullLocale(locale),
  environment: (process.env.VITE_STAGE === 'production' ? 'live' : 'test') as
    | 'live'
    | 'test'
    | 'live-us'
    | 'live-au'
    | 'live-apse'
    | 'live-in',
  amount: {
    currency: 'EUR',
    value: 0,
  },
  countryCode: country, // Mandatory in v6
  analytics: {
    enabled: false,
  },
  onSubmit: (state, component) => {
    onSubmitDropinPayment(state, component);
  },
  onAdditionalDetails: (state, component) => {
    console.log('onAdditionalDetails');
    console.log('state', state);
    console.log('component', component);
    onSubmitDropinPaymentDetails(state, component);
  },
  // Move the paymentMethodsConfiguration here - in the main config
  // paymentMethodsConfiguration: {
  //   card: {
  //     hasHolderName: true,
  //     holderNameRequired: true,
  //     enableStoreDetails: true,
  //     hideCVC: false,
  //     name: 'Credit or debit card',
  //   },
  //   paypal: {
  //     // Add PayPal specific config here if needed
  //     environment: process.env.VITE_STAGE === 'production' ? 'live' : 'test',
  //     // Include any PayPal configs you need
  //   },
  // },
});
